/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} All_Original_Pro_FeaturesInputs */

const en_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Original Pro Features`)
};

const ar_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جميع ميزات المحترفين الأصلية`)
};

const de_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Funktionen von Original Pro`)
};

const es_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas las funciones originales de Pro`)
};

const fr_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les caractéristiques de Forest Pro`)
};

const it_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutte le funzionalità originali Pro`)
};

const ja_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロ版の全機能`)
};

const ko_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 Original Pro 기능`)
};

const pt_br_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as funcionalidades do Pro Original`)
};

const ru_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все исходные функции Pro`)
};

const th_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสมบัติโปรดั้งเดิมทั้งหมด`)
};

const tr_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüm Orijinal Pro özellikleri`)
};

const zh_cn_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原专业版所有功能`)
};

const zh_tw_all_original_pro_features = /** @type {(inputs: All_Original_Pro_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原專業版所有功能`)
};

/**
* | output |
* | --- |
* | "All Original Pro Features" |
*
* @param {All_Original_Pro_FeaturesInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const all_original_pro_features = /** @type {((inputs?: All_Original_Pro_FeaturesInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_Original_Pro_FeaturesInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_all_original_pro_features(inputs)
	if (locale === "ar") return ar_all_original_pro_features(inputs)
	if (locale === "de") return de_all_original_pro_features(inputs)
	if (locale === "es") return es_all_original_pro_features(inputs)
	if (locale === "fr") return fr_all_original_pro_features(inputs)
	if (locale === "it") return it_all_original_pro_features(inputs)
	if (locale === "ja") return ja_all_original_pro_features(inputs)
	if (locale === "ko") return ko_all_original_pro_features(inputs)
	if (locale === "pt_br") return pt_br_all_original_pro_features(inputs)
	if (locale === "ru") return ru_all_original_pro_features(inputs)
	if (locale === "th") return th_all_original_pro_features(inputs)
	if (locale === "tr") return tr_all_original_pro_features(inputs)
	if (locale === "zh_cn") return zh_cn_all_original_pro_features(inputs)
	return zh_tw_all_original_pro_features(inputs)
});